import { unauthenticatedLiquidityPaths } from '@forgd/shared/regex'

export function isUnauthenticatedLiquidityPortal(href: string) {
  return unauthenticatedLiquidityPaths.test(href)
}
